@if (showHeading()) {
  <onyx-information-heading
    [class.margin]="drivers().length !== 2 && !fixedHeadingHeight()"
    [class.fixed-height]="fixedHeadingHeight()"
  >
    <ng-container titleIcon>
      @if (!drivers().length) {
        <onyx-icon name="no-user-outlined" [size]="20"></onyx-icon>
      } @else if (drivers().length > 1) {
        <onyx-tabs [tabs]="tabs()" [(value)]="selectedDriver"></onyx-tabs>
      } @else if (drivers().length === 1 && selectedDriver()) {
        <onyx-icon
          [name]="selectedDriverIcon().name"
          [size]="20"
          [onyxTooltip]="selectedDriverIcon().tooltip"
        ></onyx-icon>
      }
    </ng-container>

    @if (!drivers().length) {
      {{ 'labels.driver' | translate }}
    } @else if (selectedDriver(); as driver) {
      <div class="heading">
        <app-module-link
          module="drivers"
          color="black"
          font="f-heading-s"
          (linkClick)="openDriverModal(driver)"
        >
          {{ driver.driverData | onyxName }}
        </app-module-link>

        <app-unavailability-icon
          [unavailability]="driver.unavailability"
        ></app-unavailability-icon>

        @if (outdatedData(); as data) {
          @if (data.showIcon) {
            <onyx-icon name="alert-two-tone-filled" [size]="16"></onyx-icon>
          }

          @let duration = data.duration | duration: { singleUnit: true };

          <span
            class="outdated-time f-muted f-body-s"
            [onyxTooltip]="outdatedTooltipTemplate"
            [onyxTooltipTemplateContext]="{ duration }"
          >
            {{ duration }}
          </span>
        }
      </div>
    }

    <ng-container actions>
      @if (selectedDriver(); as driver) {
        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="32"
          icon="telephone-outlined"
          [circle]="true"
          onyxTooltip="labels.call"
          (click)="ActionHelper.makeCall(driver.driverData.privatePhone)"
        ></onyx-icon-button>
      }
    </ng-container>
  </onyx-information-heading>
}

@if (selectedDriver()) {
  @if (tachograph(); as tachograph) {
    <div class="tachograph {{ orientation() }}">
      <ng-container
        *ngTemplateOutlet="
          tachographItemTemplate;
          context: { data: workingModeData(), showEmpty: true }
        "
      ></ng-container>

      <ng-container
        *ngTemplateOutlet="
          tachographItemTemplate;
          context: { data: dailyDrivingData() }
        "
      ></ng-container>

      @if (
        !compact() ||
        (fortnightDrivingData()?.elapsed == null &&
          fortnightDrivingData()?.remaining == null)
      ) {
        <ng-container
          *ngTemplateOutlet="
            tachographItemTemplate;
            context: { data: weeklyDrivingData() }
          "
        ></ng-container>
      }

      <ng-container
        *ngTemplateOutlet="
          tachographItemTemplate;
          context: { data: fortnightDrivingData() }
        "
      ></ng-container>

      <ng-template
        let-data="data"
        let-showEmpty="showEmpty"
        #tachographItemTemplate
      >
        @if (data?.elapsed != null || data?.remaining != null || showEmpty) {
          <onyx-data-widget
            [supheading]="data.supheading"
            [gap]="4"
            [onyxTooltip]="data.tooltip"
            onyxTooltipTextAlign="left"
            [onyxTooltipDisabled]="!(!data.isOutdated && !!data.tooltip)"
          >
            <ng-container supheadingContent>
              @if (!data.isOutdated && data.supheadingDetails; as details) {
                <span class="f-muted f-body-xs">
                  {{ details }}
                </span>
              }
            </ng-container>

            <h4
              heading
              [class.f-danger]="data.isLimitExceeded && !data.isOutdated"
            >
              @if (data.isOutdated) {
                {{ 'labels.noData' | translate }}
              } @else if (data.elapsed != null) {
                {{ data.elapsed | duration: DURATION_OPTIONS }}
              } @else if (data.remaining != null) {
                -{{ data.remaining | duration: DURATION_OPTIONS }}
              } @else {
                {{ 'labels.noData' | translate }}
              }
            </h4>

            <div class="progress-container">
              <onyx-progress
                [value]="!data.isOutdated ? data.effectiveElapsed : 0"
                [max]="data.limit"
                [color]="
                  data.isLimitExceeded && !data.isOutdated
                    ? 'red'
                    : data.progressBarColor
                "
              ></onyx-progress>

              @if (
                !data.isOutdated && data.elapsed != null && data.remaining;
                as remaining
              ) {
                <p class="f-muted f-body-xs f-medium">
                  {{ data.isLimitExceeded ? '+' : '-'
                  }}{{
                    remaining
                      | duration
                        : {
                            ...DURATION_OPTIONS,
                            format: 'clock',
                            padHour: true,
                            past: true,
                            plusSign: false,
                          }
                  }}
                </p>
              }
            </div>
          </onyx-data-widget>
        }
      </ng-template>
    </div>
  } @else if (vehicle() && !vehicle()?.tachograph) {
    <onyx-message intent="neutral">
      <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

      {{ `${I18N}.noVehicleTachograph` | translate }}
    </onyx-message>
  } @else {
    <onyx-message intent="warning">
      <onyx-icon name="alert-circle-two-tone-filled" [size]="20"></onyx-icon>

      {{
        `${I18N}.${hasTelematics() ? 'noTachographData' : 'noTelematicsData'}`
          | translate
      }}

      @if (hasTelematics() && authStore.hasModule('integrations')) {
        <onyx-button
          variant="ghost"
          [size]="32"
          [routerLink]="IntegrationsRoute.INTEGRATIONS_LIST"
          (click)="close$()?.next()"
        >
          {{ 'labels.integrations' | translate }}
        </onyx-button>
      }
    </onyx-message>
  }
} @else {
  <onyx-message intent="warning">
    <onyx-icon name="alert-circle-two-tone-filled" [size]="20"></onyx-icon>

    {{
      `${I18N}.${type() === 'vehicle' ? 'noDriverInVehicle' : 'noDriverInOrder'}`
        | translate
    }}
  </onyx-message>
}

<ng-template let-duration="duration" #outdatedTooltipTemplate>
  <div class="tooltip">
    <span [innerHTML]="`${I18N}.lastUpdated` | translate: { duration }"></span>
    <span>{{ `${I18N}.lastState` | translate }}</span>
    <span>{{ `${I18N}.systemSchedule` | translate }}</span>
  </div>
</ng-template>
